import React from 'react';
import { School } from 'models/school';
import FixturesResults from 'views/School/FixturesResults';

export default function Fixtures({ school }: { school: School }) {
   return <FixturesResults school={school} mode='fixtures' />;
}
